import { useTranslation } from 'react-i18next';
import queryClient from '@/Config/api/queryClient';
import { QueryKey } from '@/Config/api/queryKey';
import { ActionDto, AIActionUsageStatsDto } from '@/Domain/api/Action/dto/Action.dto';
import { ActionBox } from '@/Domain/components/Action/ActionBox/ActionBox';
import { RemoveActionModal } from '@/Domain/components/Action/RemoveAction.modal';
import { useActivateKnowledgeBaseAction } from '@/Domain/hooks/Action/KnowledgeBaseAction/useActivateKnowledgeBaseAction';
import { MODAL_NAMES, useModalStore } from '@/Domain/store/modal.store';

type Props = {
  action: ActionDto;
  stats?: AIActionUsageStatsDto;
};

export const KnowledgeBaseActionBox = ({ action, stats }: Props) => {
  const { t } = useTranslation('knowledge_base_action');
  const { toggleModal } = useModalStore();

  const handleFetchAction = async () =>
    await queryClient.fetchQuery({
      queryKey: [QueryKey.actions.knowledgeBase.get, action.id],
    });

  const { handleActive: handleKnowledgeBaseActionActive } = useActivateKnowledgeBaseAction(action);

  const handleDelete = () => {
    toggleModal(`${MODAL_NAMES.REMOVE_ACTION_MODAL_NAME}_${action.id}`);
  };

  const handleEdit = async () => {
    const knowledgeBaseAction = await queryClient.ensureQueryData({
      queryKey: [QueryKey.actions.knowledgeBase.get, action.id],
    });
    toggleModal(MODAL_NAMES.KNOWLEDGE_BASE_ACTION_SHEET, { knowledgeBaseAction });
  };

  return (
    <>
      <ActionBox
        dataTestId="knowledge-base-action"
        action={action}
        stats={stats}
        onMouseEnterAction={handleFetchAction}
        onActive={handleKnowledgeBaseActionActive}
        onEdit={handleEdit}
        onDelete={handleDelete}
        buttonLabel={t('button.edit')}
      />

      <RemoveActionModal actionId={action.id} />
    </>
  );
};
